export const produtosInitialState = {
  produtos: [],
  novoProduto: [],
  produtoRemovido: [],
  produto: [],
  produtoEditado: [],
};
